import { render, staticRenderFns } from "./UsersAdminPanelSkeletonTable.vue?vue&type=template&id=0eb72149&"
import script from "./UsersAdminPanelSkeletonTable.vue?vue&type=script&lang=ts&"
export * from "./UsersAdminPanelSkeletonTable.vue?vue&type=script&lang=ts&"
import style0 from "./UsersAdminPanelSkeletonTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports